<div class="horizinns-container terms-container center">
    <div class="mat-row margin-auto text-center">
        <img src="/assets/images/logo_full_900.png" class="main-logo" alt="Horizinns logo" />
        <mat-card class="terms-card left">
            <mat-card-header class="margin-auto">
                <h1 class="center">Privacy Policy</h1>
            </mat-card-header>
            <mat-card-content>
                <h3>Information We Collect</h3>
                <ol>
                    <li>
                        Personal Information:
                        <ol>
                            <li>
                                We may collect the following personal information from users (Hosts and Guests):
                                <ul>
                                    <li>Name</li>
                                    <li>Email address</li>
                                    <li>Phone number</li>
                                    <li>Mailing address</li>
                                    <li>Payment and billing information</li>
                                    <li>Government-issued ID (if identity verification is needed)</li>
                                </ul>
                            </li>
                        </ol>
                    </li>
                    <li>
                        Non-Personal Information:
                        <ol>
                            <li>
                                We also collect data that does not directly identify you:
                                <ul>
                                    <li>Browser type and device info</li>
                                    <li>IP address</li>
                                    <li>Geolocation (if enabled)</li>
                                    <li>Site usage data (e.g., pages visited, time on site)</li>
                                </ul>
                            </li>

                        </ol>
                    </li>
                </ol>

                <h3>How We Use Your Information</h3>
                <ol>
                    <li>
                        We use the information we collect to:
                        <ul>
                            <li>Create and manage user accounts</li>
                            <li>Facilitate subscriptions and payments</li>
                            <li>Communicate with users</li>
                            <li>Improve our Platform and services</li>
                            <li>Detect and prevent fraud or abuse</li>
                            <li>Comply with legal obligations</li>
                        </ul>
                    </li>
                </ol>
                
                <h3>Marketing Use of Submitted Content</h3>
                <p>By uploading, submitting, or posting any photographs, images, descriptions, or other
                content to the Horizinns platform, the user grants Horizinns, LLC a non-exclusive, royalty-
                free, worldwide license to use, reproduce, modify, publish, display, distribute, and promote
                such content for marketing, advertising, and promotional purposes.</p>
                <p>This includes, but is not limited to, use on:</p>
                    <ul>
                        <li>The Horizinns website</li>
                        <li>Social media platforms</li>
                        <li>Digital advertisements</li>
                        <li>Email campaigns</li>
                        <li>Printed marketing materials</li>
                    </ul>
                <p>
                The user represents and warrants that they have the legal right and authority to grant this
                license and that the submitted content does not infringe on the rights of any third party.
                Horizinns will not sell submitted content as standalone media or claim ownership of the
                original material; ownership remains with the original content creator.
                </p>
                
                <h3>Cookies and Tracking Technologies</h3>
                <p>We use cookies and similar technologies to:</p>
                <ul>
                    <li>Remember your preferences</li>
                    <li>Track user activity</li>
                    <li>Improve website functionality</li>
                </ul>
                <p>You can control cookie settings through your browser. Disabling cookies may limit some features.</p>

                <h3>Sharing Your Information</h3>
                <ol>
                    <li>
                        We do not sell your personal data. We may share your data with:
                        <ul>
                            <li>Service providers (e.g., payment processors, hosting companies)</li>
                            <li>Legal authorities when required by law</li>
                            <li>Business partners in the event of a merger, sale, or acquisition</li>
                        </ul>
                    </li>
                </ol>
                <p>All third parties are required to protect your data and only use it as necessary.</p>

                <h3>Data Security</h3>
                <p>We take reasonable measures to protect your information, including encryption, firewalls, and secure servers. However, no method of transmission over the Internet is 100% secure.</p>
                
                <h3>Your Rights and Choices</h3>
                Depending on your jurisdiction, you may have rights to:
                <ul>
                    <li>Access or request a copy of your data</li>
                    <li>Correct inaccurate data</li>
                    <li>Delete your data</li>
                    <li>Withdraw consent</li>
                    <li>Object to data processing</li>
                    <li>File a complaint with a data protection authority</li>
                </ul>
                <p>To exercise your rights, contact us at: support@horizinns.com</p>

                <h3>Children's Privacy</h3>
                <p>Our services are not intended for children under 18. We do not knowingly collect data from minors. If we become aware of such collection, we will delete the data promptly.</p>

                <h3>Data Retention</h3>
                <p>We retain personal data only as long as needed for the purposes stated in this policy or as required by law.</p>

                <h3>Third-Party Links</h3>
                <p>Our Platform may contain links to third-party websites. We are not responsible for the privacy practices or content of these sites.</p>

                <h3>Changes to This Policy</h3>
                <p>We may update this Privacy Policy at any time. If we make material changes, we will notify users via the website or email. Your continued use of the Platform constitutes your acceptance of the revised policy.</p>

                <h3>Contact Us</h3>
                <p>
                    If you have questions or concerns about this Privacy Policy, please contact:<br>
                    Horizinns, LLC<br>
                    <button mat-flat-button class="metallic-text-btn-blue" routerLink="/contact">Contact Us</button>
                </p>
            </mat-card-content>
        </mat-card>
    </div>
</div>
